import styled from 'styled-components'

export const ChipWrapper = styled.div<{ $inline?: boolean }>`
  ${({ $inline }) =>
    $inline
      ? `position: relative;`
      : `
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%) scale(var(--zoom-scale, 1));
    transform-origin: center bottom;
  `}
  display: flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  background: var(--color-node-bg);
  border: 1px solid var(--color-border-dark);
  border-radius: 20px;
  padding: 0 10px;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  cursor: default;
`

export const ProgressBarTrack = styled.div`
  position: relative;
  width: 90px;
  height: 4px;
  background: var(--color-border);
  border-radius: 2px;
  overflow: visible;
  flex-shrink: 0;
`

export const ProgressBarFill = styled.div<{ $score: number; $meetsThreshold: boolean }>`
  height: 100%;
  width: ${({ $score }) => ($score === 0 ? 4 : $score)}%;
  max-width: 100%;
  border-radius: 2px;
  transition:
    width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    background-color 0.4s ease;
  background-color: ${({ $meetsThreshold }) => ($meetsThreshold ? '#10b981' : '#6E53F9')};
`

/** Threshold marker line — a vertical tick on the bar at the aiThreshold position */
export const ThresholdMarker = styled.div<{ $position: number }>`
  position: absolute;
  left: ${({ $position }) => $position}%;
  top: -2px;
  width: 2px;
  height: 8px;
  background: var(--color-text-secondary);
  border-radius: 1px;
  opacity: 0.5;
  transform: translateX(-50%);
`
